import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function Logout() {
  localStorage.setItem("accessToken", "");
  localStorage.setItem("refreshToken", "");
  localStorage.setItem("userId", "");
  localStorage.setItem("firstName", "");
  localStorage.setItem("lastName", "");
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/login");
  }, [navigate]);
}

export default Logout;
